<div class="tw-text-center tw-mb-4 sm:tw-mb-8">
  <h1
    class="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-medium tw-text-gray-900 dark:tw-text-gray-100 tw-mb-3">
    {{ staticText }}
    <span
      class="tw-inline-block tw-text-primary_purple-600 dark:tw-text-primary_purple-400 tw-transition-opacity tw-duration-500"
      [class.tw-opacity-0]="isAnimating"
      [class.tw-opacity-100]="!isAnimating">
      {{ currentText }}
    </span>
    <span class="tw-inline-block tw-animate-pulse">?</span>
  </h1>
  <p class="tw-text-base tw-text-gray-600 dark:tw-text-gray-400 tw-max-w-2xl tw-mx-auto">
    {{ subheaderText }}
  </p>
</div>
